// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bridge"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 16.0004H3M3 16.0004H21M3 16.0004V3M3 16.0004V21.0004M21 16.0004H22M21 16.0004V3M21 16.0004V21.0004M7 16L7 8M12 16.0004V8M12 8C7.41421 8 4.58088 6.8317 3.5 6.28096M12 8C16.5864 8 19.4198 6.8314 20.5004 6.28074M17 16V8","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bridge')
export default class BridgeIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge',
    }
  }
}
